import { getLogoutUrl } from '@buffer-mono/shared-utils/urls'

export function redirectToLegacyLogout(): void {
  if (typeof window === 'undefined') return

  if (window.location.pathname === '/embedded-compose') {
    window.parent.postMessage({ type: 'buffer|close' }, '*')
    return
  }

  const logoutUrl = getLogoutUrl(window.location.href)

  if (window.location.href !== logoutUrl) {
    window.location.replace(logoutUrl)
  }
}
